import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Modal, Row, Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import { GaEvent } from "../App";
import addLogo from "../assets/plus.png";
import { utilities } from "../components/utilities";
import {
  ADD_COMPETENCY, GET_GOAL_STATIC_DATA
} from "../constants/urlConstants";

const Competency = () => {
  return (
    <Container className="main-container">
      <Row>
        <Col>
          <CompetencyPanel />
        </Col>
      </Row>
    </Container>
  );
};

const CompetencyPanel = () => {
  const [competency, setCompetency] = useState("");
  const [isLoading, setLoading] = useState(null);
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [CompetencyName, setCompetencyName] = useState();
  const [refreshKey, setRefreshKey] = useState(0);
  const [isRedundant, setRedundantCourse] = useState(false);

  const reset = () => {
    setValidated(false);
    setCompetencyName('');
  };

  useEffect(() => {
    loadStaticData();
  }, [refreshKey]);

  const loadStaticData = async () => {
    try {
      setLoading(true);
      let result = await axios.get(GET_GOAL_STATIC_DATA);
      if (result) {
        if (result.data.errorType === "Error") {
          utilities.showToast(result.data.errorMessage);
        } else {
          setCompetency(result.data.filter((x) => x.type === "competency"));
        }
      }
      setLoading(false);
    } catch (err) {
      console.log("error", err);
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    const form = e.currentTarget;
    let dataToCheck = competency?.filter(courseData => courseData.description.toLowerCase() === CompetencyName.toLowerCase());
    if (dataToCheck.length > 0) {
      setRedundantCourse(true)
      e.preventDefault();
      e.stopPropagation();
      setLoading(false);
    } else {
      setRedundantCourse(false)
      if (form.checkValidity() === false) {
        e.preventDefault();
        e.stopPropagation();
        setLoading(false);
      } else {
        e.preventDefault();
        const payload = { competencyName: CompetencyName };
        axios.post(ADD_COMPETENCY, payload).then((res) => {
          if (res.data.errorType === "Error") {
            utilities.showToast(res.data.errorMessage);
          } else if (res.data.affectedRows > 0) {
            GaEvent("Competency", "New Competency Added", CompetencyName);
            utilities.showToast(
              "Added " + res.data.affectedRows + " New Competency!!"
            );
            reset();
          } else if (res.data.errorMessage) {
            utilities.showToast(res.data.errorMessage);
          }
          setRefreshKey((oldKey) => oldKey + 1);
          setLoading(false);
        }).catch((err) => {
          setLoading(false);
          console.log("err", err);
        });
        setShow(false);
      }
      setValidated(true);
    }
  };

  return (
    <>
      {isLoading && isLoading === true && <>
        <Row>
          <Col>
            <div className="d-flex justify-content-center align-items-center" style={{ height: '30rem' }}>
              <Spinner animation="grow" variant="primary" />
            </div>
          </Col>
        </Row>
      </>}

      {!isLoading && isLoading === false && (
        <Container>
          <div>
            <i className="fa fa-plus-circle fa-2x add-logo" onClick={handleShow} src={addLogo} />
            <Modal show={show} onHide={handleClose}>
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title>Add Competency</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form.Group controlId="formBasicCompetencyName">
                    <Form.Label>Competency Name</Form.Label>
                    <Form.Control
                      type="name"
                      maxLength={100}
                      value={CompetencyName}
                      onChange={(e) => {
                        setCompetencyName(e.target.value);
                        setRedundantCourse(false)
                      }}
                      autoComplete="off"
                      required
                    />
                    {isRedundant && (
                      <Form.Text type="invalid">
                        <div class="text-danger">The Competency already Exists!</div>
                      </Form.Text>
                    )}
                    <Form.Control.Feedback type="invalid">
                      Competency Name is mandatory
                    </Form.Control.Feedback>
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    Close
                  </Button>
                  <Button variant="primary" type="submit">
                    Save
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal>
          </div>
          <p className="mt-5 mb-4 mx-0">Manage Competency Groups.</p>

          <table id="my-courses-list" className="table table-bordered table-striped">
            <thead className="thead-light">
              <tr>
                <th>Competency</th>
              </tr>
            </thead>
            <tbody>
              {competency && competency.length > 0 ? (
                competency.map((item) => {
                  return (
                    <tr>
                      <td>
                        <span className="vertical-sub">{item.description}</span>
                        <span className="float-right">
                          <EditAction item={item} onSave={() => setRefreshKey((oldKey) => oldKey + 1)} />
                          <DeleteAction item={item} onDelete={() => setRefreshKey((oldKey) => oldKey + 1)}  />
                        </span>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <h3>No Competency added.</h3>
              )}
            </tbody>
          </table>
        </Container>

      )}
    </>

  );
};

const EditAction = ({ item, onSave }) => {
  const [name, setName] = useState(item.description);
  const [show, setShow] = useState(false);
  const [btnText, setBtnText] = useState('Save');
  const [isSaving, setSaving] = useState(false);
  const [validated, setValidated] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSubmit = (e) => {
    disableSave(true);
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      disableSave(false);
    } else {
      const payload = { competencyId: item.id, competencyName: name };
      axios.put(ADD_COMPETENCY, payload).then((res) => {
        disableSave(false);
        handleClose();
        onSave();
        if (res.data.errorType === 'Error' || res.data.errorMessage) {
          utilities.showToast(res.data.errorMessage);
        } if (res.data.affectedRows > 0) {
          GaEvent("Competency", "Saved Competency", name);
          utilities.showToast("Competency Saved Successfully!");
        }
      }).catch((err) => {
        disableSave(false);
        console.log("err", err);
      });
    }
    setValidated(true);
  };

  const disableSave = (state) => {
    setBtnText(state ? 'Saving' : 'Save');
    setSaving(state);
  }

  return (
    <>
      <i className="fa fa-edit fa-lg cursor-pointer mx-2" onClick={handleShow} />
      <Modal show={show} onHide={handleClose} contentClassName="w-100">
        <Form onSubmit={handleSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Competency</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="formBasicCompetencyName">
              <Form.Label>Competency</Form.Label>
              <Form.Control type="name"
                maxLength={100}
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoComplete="off"
                required />
              <Form.Control.Feedback type="invalid">
                Competency name is mandatory
              </Form.Control.Feedback>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>Cancel</Button>
            <Button variant="success" type="submit" disabled={isSaving}>{btnText}</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}

const DeleteAction = ({ item, onDelete }) => {
  const [show, setShow] = useState(false);
  const [btnText, setBtnText] = useState('Delete');
  const [isSaving, setSaving] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleDelete = (e) => {
    disableSave(true);
    if (item && item.id && item.description) {
      const payload = { competencyId: item.id, competencyName: item.description };
      axios.delete(ADD_COMPETENCY , {data: payload}).then((res) => {
        disableSave(false);
        handleClose();
        onDelete();
        if (res.data.errorType === 'Error' || res.data.errorMessage) {
          utilities.showToast(res.data.errorMessage);
        } else if (res.data.affectedRows === 0) { 
          utilities.showToast(`${item.description} competency cannot be deleted.`);
        } else if (res.data.affectedRows > 0) {
          GaEvent("Competency", "Removed Competency", item.description);
          utilities.showToast(`${item.description} competency removed successfully.`);
        }
      }).catch((err) => {
        disableSave(false);
        console.log("err", err);
      });
    } else {
      disableSave(false);
      handleClose();
      utilities.showToast("Competency details not found.");
    }
  };

  const disableSave = (state) => {
    setBtnText(state ? 'Deleting' : 'Delete');
    setSaving(state);
  }

  return (
    <>
      <i className="fa fa-trash fa-lg cursor-pointer" onClick={handleShow} />
      <Modal show={show} onHide={handleClose} contentClassName="w-100">
        <Modal.Header closeButton>
          <Modal.Title>Delete Competency</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure want to delete the <b>{item.description}</b> competency?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Cancel</Button>
          <Button variant="danger" disabled={isSaving} onClick={handleDelete}>{btnText}</Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    currentUserDetail: state.CurrentUserReducer.currentUserDetail,
  };
};

export default connect(mapStateToProps)(Competency);
